// Dev/test accounts allowed via Google sign-in (no @vnrvjiet.in required).
// Backend roles are resolved from data/users.json via GET /api/auth/user.
export const DEV_ACCOUNT_ROLES = {
  'swarooproyal777@gmail.com': 'manager',
  'darkslayer1523@gmail.com': 'spoc',
};

export const COLLEGE_EMAIL_REGEX = /^[^\s@]+@vnrvjiet\.in$/i;

export function getDevAccountRole(email) {
  if (!email) return null;
  return DEV_ACCOUNT_ROLES[email.trim().toLowerCase()] || null;
}

export function resolveFirestoreRole(email) {
  const devRole = getDevAccountRole(email);
  if (devRole) return devRole;
  if (COLLEGE_EMAIL_REGEX.test(email)) return 'student';
  return 'student';
}

export function isAllowedToSignIn(email) {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return COLLEGE_EMAIL_REGEX.test(normalized) || Boolean(DEV_ACCOUNT_ROLES[normalized]);
}
